const errorParser = ({ error, setLoading, showSnackbar, onSameEmailExists, onWrongPassword }) => {
  setLoading({ show: false, text: '' });
  if (!error.response || !error.response.hasOwnProperty('data')) return;
  if (error.response.data.errors) {
    showSnackbar(error.response.data.errors[0].description);
  } else if (
    error.response.data.non_field_errors &&
    error.response.data.non_field_errors[0] === 'Bidder with this email exists'
  ) {
    showSnackbar('Participant with this e-mail is registered');
    if (onSameEmailExists) onSameEmailExists();
  } else if (
    error.response.data.old_password &&
    error.response.data.old_password[0] === 'Wrong password'
  ) {
    showSnackbar('The current password you entered is incorrect');
    if (onWrongPassword) onWrongPassword();
  } else {
    showSnackbar(error.response.data);
  }
};

export default errorParser;
